'use client'

import { useEffect, useState } from 'react'
import { Wallet } from 'lucide-react'

const VISIBLE_MS = 1200
const FADE_MS = 400

export default function SplashScreen() {
  const [phase, setPhase] = useState<'visible' | 'exiting' | 'hidden'>('visible')

  useEffect(() => {
    const hideTimer = setTimeout(() => setPhase('exiting'), VISIBLE_MS)
    const removeTimer = setTimeout(() => setPhase('hidden'), VISIBLE_MS + FADE_MS)
    return () => {
      clearTimeout(hideTimer)
      clearTimeout(removeTimer)
    }
  }, [])

  if (phase === 'hidden') return null

  return (
    <div
      className={`fixed inset-0 z-[100] flex flex-col items-center justify-center bg-header ${phase === 'exiting' ? 'splash-exit' : ''}`}
      aria-hidden="true"
    >
      <div className="relative flex items-center justify-center">
        <span className="splash-ring absolute inline-block h-20 w-20 rounded-full bg-header-foreground/20" />
        <div className="splash-icon relative flex h-20 w-20 items-center justify-center rounded-2xl bg-header-foreground/10">
          <Wallet className="h-10 w-10 text-header-foreground" />
        </div>
      </div>
      <p className="splash-name font-display mt-5 text-2xl font-extrabold text-header-foreground">
        PocketWise
      </p>
    </div>
  )
}
